// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/images/pamo-zone/hoverbg.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pamo-zone-section {
  padding: 0 !important;
  margin: 0 !important;
}

.shimmer {
  padding: 0px 10%;
}

.zone-banner {
  padding: 0px 10%;
}

.blog-content-section {
  padding: 10px 25%;
}

.blog-header {
  font-size: 50px;
}

.for-mobile {
  display: none;
}

.video-header {
  font-size: 50px;
  padding: 50px 10%;
  margin-bottom: -70px;
}

.article-body {
  text-align: justify;
}

pamo-zone-nav {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
}

.pamo-zone-btn {
  padding: 10px 25px !important;
  border-radius: 50px;
}

.pamo-zone-phone-btn {
  padding: 10px 10px !important;
  border-radius: 50px;
}

.menu-link-row {
  position: absolute;
  top: 0%;
  width: 100%;
  padding: 10px 10%;
}

.menu-btn-row {
  position: absolute;
  bottom: 10%;
  width: 100%;
  padding: 10px 10%;
}

video {
  width: 100%;
  height: 100vh;
  object-fit: cover;
}

.watch-vid-btn {
  border-radius: 40px;
}

.text-section {
  position: absolute;
  bottom: 80px;
  width: 100%;
  padding: 0px 10%;
}

.sub-text {
  width: 500px;
}

.nav-section {
  padding: 10px 10%;
}

.video-carousel {
  background: #7062f9;
  height: 250px !important;
  width: 400px !important;
  transition: transform 0.3s ease;
}

.video-carousel:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  transform: translateY(-25px);
}

.play-icon {
  font-size: 80px;
  opacity: 0.5;
}

.video-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.close-modal {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
  color: white;
}

.video-modal-show {
  background: transparent !important;
  height: auto !important;
}

.carousel-text {
  font-size: 13px;
}

.card-text {
  font-size: 13px;
}

.blog-card-container {
  margin-top: 7%;
  padding: 10px 10%;
  width: 100%;
}

.swiper-container {
  padding-right: 0 !important;
  margin-right: 0 !important;
}

.for-mobile-view {
  display: none;
}

.videos-card-container {
  padding-left: 8%;
  display: flex;
  overflow-y: hidden;
  overflow-x: auto;
  width: 100%;
}

@media only screen and (max-width: 1300px) {
  .blog-image {
    width: 120px !important;
    height: 110px !important;
  }
}
@media only screen and (max-width: 1199px) {
  .blog-content-section {
    padding: 10px 10%;
  }
}
@media only screen and (max-width: 992px) {
  .blog-card-container {
    margin-bottom: 8% !important;
  }
}
@media only screen and (max-width: 767px) {
  .blog-header {
    font-size: 40px;
    text-align: center;
  }
  .video-header {
    font-size: 40px;
    text-align: center;
  }
}
@media only screen and (max-width: 705px) {
  .pamo-zone-btn {
    padding: 0px 25px !important;
    border-radius: 50px;
    font-size: 15px !important;
  }
  .pamo-zone-phone-btn {
    padding: 5px 10px !important;
    border-radius: 50px;
    font-size: 13px !important;
  }
}
@media only screen and (max-width: 680px) {
  .pamo-zone-btn {
    padding: 0px 25px !important;
    border-radius: 50px;
    font-size: 15px !important;
    margin-left: -6% !important;
  }
}
@media only screen and (max-width: 654px) {
  .watch-vid-btn {
    padding: 10px 25px !important;
  }
  .watch-vid-btn .btn-text {
    margin-left: 2.5% !important;
    font-size: 15px !important;
  }
  .watch-vid-btn .play-icon {
    margin-left: -5.5% !important;
  }
}
@media only screen and (max-width: 599px) {
  .blog-header {
    font-size: 30px;
    text-align: center;
  }
  .video-header {
    font-size: 30px;
    text-align: center;
  }
}
@media only screen and (max-width: 564px) {
  .pamo-zone-btn {
    padding: 20px 25px !important;
    border-radius: 50px;
    font-size: 15px !important;
    margin-left: -10% !important;
  }
}
@media only screen and (max-width: 557px) {
  .watch-vid-btn {
    padding: 20px 35px !important;
    width: 200px;
  }
  .watch-vid-btn .btn-text {
    margin-left: 2.5% !important;
    font-size: 15px !important;
  }
  .watch-vid-btn .play-icon {
    margin-left: -15.5% !important;
    font-size: 20px !important;
  }
}
@media only screen and (max-width: 544px) {
  .menu-link-row {
    padding: 0px 5% !important;
  }
}
@media only screen and (max-width: 530px) {
  .for-desktop {
    display: none !important;
  }
  .for-movie {
    display: show;
  }
}
@media only screen and (max-width: 482px) {
  .home-btn {
    padding: 10px 10px !important;
  }
  .home-icon {
    font-size: 25px !important;
  }
  .phone-icon {
    font-size: 18px !important;
  }
}
@media only screen and (max-width: 530px) {
  .blog-card-structure {
    display: block !important;
  }
  .blog-image {
    width: 100% !important;
    height: 100% !important;
  }
}
@media only screen and (max-width: 576px) {
  .video-container {
    display: none !important;
  }
  .menu-link-row {
    position: relative;
    padding-bottom: 5px;
    border-bottom: 1px solid rgba(192, 192, 192, 0.288);
  }
  .pamo-zone-btn {
    color: #7062f9 !important;
  }
  .menu-btn-row {
    display: none !important;
  }
  .btn-talk-to-us {
    display: none !important;
  }
}
@media only screen and (max-width: 430px) {
  .videos-card-container {
    display: none !important;
  }
  .for-mobile-view {
    display: block;
  }
  .video-carousel {
    background: #7062f9;
    height: 250px !important;
    width: 385px !important;
    transition: transform 0.3s ease;
  }
}
@media only screen and (max-width: 400px) {
  .video-carousel {
    background: #7062f9;
    height: 200px !important;
    width: 100% !important;
    transition: transform 0.3s ease;
  }
}
.custom-pagination {
  margin-top: 10px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/presentation/main/pamo-zone/pamo-zone.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,oBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,oBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,gBAAA;AACF;;AAEA;EACE,6BAAA;EACA,mBAAA;AACF;;AAEA;EACE,6BAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,iBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAOA;EACE,mBAAA;EACA,wBAAA;EACA,uBAAA;EACA,+BAAA;AAJF;;AAOA;EACE,yDAAA;EACA,4BAAA;AAJF;;AAOA;EACE,eAAA;EACA,YAAA;AAJF;;AAOA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAJF;;AAOA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;AAJF;;AAOA;EACE,kCAAA;EACA,uBAAA;AAJF;;AAOA;EACE,eAAA;AAJF;;AAOA;EACE,eAAA;AAJF;;AAMA;EACE,cAAA;EACA,iBAAA;EACA,WAAA;AAHF;;AAMA;EACE,2BAAA;EACA,0BAAA;AAHF;;AAMA;EACE,aAAA;AAHF;;AAMA;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AAHF;;AAMA;EACE;IACE,uBAAA;IACA,wBAAA;EAHF;AACF;AAMA;EACE;IACE,iBAAA;EAJF;AACF;AAOA;EACE;IACE,4BAAA;EALF;AACF;AASA;EACE;IACE,eAAA;IACA,kBAAA;EAPF;EAUA;IACE,eAAA;IACA,kBAAA;EARF;AACF;AAcA;EACE;IACE,4BAAA;IACA,mBAAA;IACA,0BAAA;EAZF;EAeA;IACE,4BAAA;IACA,mBAAA;IACA,0BAAA;EAbF;AACF;AAgBA;EACE;IACE,4BAAA;IACA,mBAAA;IACA,0BAAA;IACA,2BAAA;EAdF;AACF;AAiBA;EACE;IACE,6BAAA;EAfF;EAgBE;IACE,4BAAA;IACA,0BAAA;EAdJ;EAgBE;IACE,6BAAA;EAdJ;AACF;AAiBA;EACE;IACE,eAAA;IACA,kBAAA;EAfF;EAkBA;IACE,eAAA;IACA,kBAAA;EAhBF;AACF;AAsBA;EACE;IACE,6BAAA;IACA,mBAAA;IACA,0BAAA;IACA,4BAAA;EApBF;AACF;AAuBA;EACE;IACE,6BAAA;IACA,YAAA;EArBF;EAsBE;IACE,4BAAA;IACA,0BAAA;EApBJ;EAsBE;IACE,8BAAA;IACA,0BAAA;EApBJ;AACF;AAwBA;EACE;IACE,0BAAA;EAtBF;AACF;AAyBA;EACE;IACE,wBAAA;EAvBF;EA0BA;IACE,aAAA;EAxBF;AACF;AA2BA;EACE;IACE,6BAAA;EAzBF;EA4BA;IACE,0BAAA;EA1BF;EA6BA;IACE,0BAAA;EA3BF;AACF;AA8BA;EACE;IACE,yBAAA;EA5BF;EA+BA;IACE,sBAAA;IACA,uBAAA;EA7BF;AACF;AAgCA;EACE;IACE,wBAAA;EA9BF;EAiCA;IACE,kBAAA;IACA,mBAAA;IACA,mDAAA;EA/BF;EAkCA;IACE,yBAAA;EAhCF;EAmCA;IACE,wBAAA;EAjCF;EAoCA;IACE,wBAAA;EAlCF;AACF;AAqCA;EACE;IACE,wBAAA;EAnCF;EAqCA;IACE,cAAA;EAnCF;EAsCA;IACE,mBAAA;IACA,wBAAA;IACA,uBAAA;IACA,+BAAA;EApCF;AACF;AAwCA;EACE;IACE,mBAAA;IACA,wBAAA;IACA,sBAAA;IACA,+BAAA;EAtCF;AACF;AAmDA;EACE,gBAAA;EACA,kBAAA;AAjDF","sourcesContent":[".pamo-zone-section {\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n.shimmer {\n  padding: 0px 10%;\n}\n\n.zone-banner {\n  padding: 0px 10%;\n}\n\n.blog-content-section {\n  padding: 10px 25%;\n}\n\n.blog-header{\n  font-size:50px;\n}\n\n.for-mobile{\n  display:none;\n}\n\n.video-header{\n  font-size:50px;\n  padding:50px 10%;\n  margin-bottom: -70px;\n}\n\n.article-body {\n  text-align: justify;\n}\n\npamo-zone-nav {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  overflow: hidden;\n}\n\n.pamo-zone-btn {\n  padding: 10px 25px !important;\n  border-radius: 50px;\n}\n\n.pamo-zone-phone-btn {\n  padding: 10px 10px !important;\n  border-radius: 50px;\n}\n\n.menu-link-row {\n  position: absolute;\n  top: 0%;\n  width: 100%;\n  padding: 10px 10%;\n}\n\n.menu-btn-row {\n  position: absolute;\n  bottom: 10%;\n  width: 100%;\n  padding: 10px 10%;\n}\n\nvideo {\n  width: 100%;\n  height: 100vh;\n  object-fit: cover;\n}\n\n.watch-vid-btn {\n  border-radius: 40px;\n}\n\n.text-section {\n  position: absolute;\n  bottom: 80px;\n  width: 100%;\n  padding: 0px 10%;\n}\n\n.sub-text {\n  width: 500px;\n}\n\n.nav-section {\n  padding: 10px 10%;\n  // position: absolute;\n  //   z-index: 1;\n  //   color: #fff;\n  //   text-align: center;\n  //   top:-50%;\n}\n\n.video-carousel {\n  background: #7062f9;\n  height: 250px !important;\n  width: 400px !important;\n  transition: transform 0.3s ease;\n}\n\n.video-carousel:hover {\n  background-image: url(\"../../../assets/images/pamo-zone/hoverbg.gif\");\n  transform: translateY(-25px);\n}\n\n.play-icon {\n  font-size: 80px;\n  opacity: 0.5;\n}\n\n.video-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.8);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.close-modal {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  z-index: 1;\n  color: white;\n}\n\n.video-modal-show {\n  background: transparent !important;\n  height: auto !important;\n}\n\n.carousel-text {\n  font-size: 13px;\n}\n\n.card-text {\n  font-size: 13px;\n}\n.blog-card-container {\n  margin-top: 7%;\n  padding: 10px 10%;\n  width: 100%;\n}\n\n.swiper-container {\n  padding-right: 0 !important;\n  margin-right: 0 !important;\n}\n\n.for-mobile-view {\n  display: none;\n}\n\n.videos-card-container {\n  padding-left: 8%;\n  display: flex;\n  overflow-y: hidden;\n  overflow-x: auto;\n  width: 100%;\n}\n\n@media only screen and (max-width: 1300px) {\n  .blog-image {\n    width: 120px !important;\n    height: 110px !important;\n  }\n}\n\n@media only screen and (max-width: 1199px) {\n  .blog-content-section {\n    padding: 10px 10%;\n  }\n}\n\n@media only screen and (max-width: 992px) {\n  .blog-card-container {\n    margin-bottom: 8% !important ;\n  }\n  \n}\n\n@media only screen and (max-width: 767px) {\n  .blog-header{\n    font-size:40px;\n    text-align: center;\n  }\n\n  .video-header{\n    font-size:40px;\n    text-align: center;\n  }\n\n}\n\n\n\n@media only screen and (max-width: 705px) {\n  .pamo-zone-btn {\n    padding: 0px 25px !important;\n    border-radius: 50px;\n    font-size: 15px !important;\n  }\n\n  .pamo-zone-phone-btn {\n    padding: 5px 10px !important;\n    border-radius: 50px;\n    font-size: 13px !important;\n  }\n}\n\n@media only screen and (max-width: 680px) {\n  .pamo-zone-btn {\n    padding: 0px 25px !important;\n    border-radius: 50px;\n    font-size: 15px !important;\n    margin-left: -6% !important;\n  }\n}\n\n@media only screen and (max-width: 654px) {\n  .watch-vid-btn {\n    padding: 10px 25px !important;\n    .btn-text {\n      margin-left: 2.5% !important;\n      font-size: 15px !important;\n    }\n    .play-icon {\n      margin-left: -5.5% !important;\n    }\n  }\n}\n@media only screen and (max-width: 599px) {\n  .blog-header{\n    font-size:30px;\n    text-align: center;\n  }\n\n  .video-header{\n    font-size:30px;\n    text-align: center;\n  }\n}\n\n\n\n\n@media only screen and (max-width: 564px) {\n  .pamo-zone-btn {\n    padding: 20px 25px !important;\n    border-radius: 50px;\n    font-size: 15px !important;\n    margin-left: -10% !important;\n  }\n}\n\n@media only screen and (max-width: 557px) {\n  .watch-vid-btn {\n    padding: 20px 35px !important;\n    width: 200px;\n    .btn-text {\n      margin-left: 2.5% !important;\n      font-size: 15px !important;\n    }\n    .play-icon {\n      margin-left: -15.5% !important;\n      font-size: 20px !important;\n    }\n  }\n}\n\n@media only screen and (max-width: 544px) {\n  .menu-link-row {\n    padding: 0px 5% !important;\n  }\n}\n\n@media only screen and (max-width: 530px) {\n  .for-desktop{\n    display: none !important; \n  }\n\n  .for-movie{\n    display: show;\n  }\n}\n\n@media only screen and (max-width: 482px) {\n  .home-btn {\n    padding: 10px 10px !important;\n  }\n\n  .home-icon {\n    font-size: 25px !important;\n  }\n\n  .phone-icon {\n    font-size: 18px !important;\n  }\n}\n\n@media only screen and (max-width: 530px) {\n  .blog-card-structure {\n    display: block !important;\n  }\n\n  .blog-image {\n    width: 100% !important;\n    height: 100% !important;\n  }\n}\n\n@media only screen and (max-width: 576px) {\n  .video-container{\n    display: none !important;\n  }\n\n  .menu-link-row{\n    position: relative;\n    padding-bottom:5px;\n    border-bottom: 1px solid rgba(192, 192, 192, 0.288) ;\n  }\n\n  .pamo-zone-btn{\n    color:#7062f9 !important;\n  }\n\n  .menu-btn-row {\n    display: none !important;\n  }\n\n  .btn-talk-to-us{\n    display: none !important;\n  }\n}\n\n@media only screen and (max-width: 430px) {\n  .videos-card-container {\n    display: none !important;\n  }\n  .for-mobile-view {\n    display: block;\n  }\n\n  .video-carousel {\n    background: #7062f9;\n    height: 250px !important;\n    width: 385px !important;\n    transition: transform 0.3s ease;\n  }\n}\n\n\n@media only screen and (max-width: 400px) {\n  .video-carousel {\n    background: #7062f9;\n    height: 200px !important;\n    width: 100% !important;\n    transition: transform 0.3s ease;\n  }\n}\n\n// @media only screen and (max-width: 371px) {\n//   .phone-circle {\n//     display: none !important;\n//   }\n\n//   .pamo-zone-phone-btn {\n//     padding: 10px 10px !important;\n//   }\n// }\n\n.custom-pagination {\n  margin-top: 10px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
